<div class="container-fluid"  >
  <div class="grid">
    <div class="field col-4">
      <label for="manager">Name des Inputs</label>
      <p-inputgroup>
        <input inputid="manager"  maxlength="200" [readonly]="this.isReadOnly" style="width: 100%;"   [(ngModel)]="taskModel.name" type="text" pInputText />

        <p-button [disabled]="this.isReadOnly" (click)="taskModel.name = '';" type="button"  icon="pi pi-times"
          severity="info"          ></p-button>

      </p-inputgroup>
    </div>
    <div class="field col-4">
      <label class="w-full" for="liste">Liste</label>
      <p-select  class="w-full"  appendTo="body" [disabled]="!canEditList()" id="liste" [options]="validationProfiles()" optionLabel="listName"
      placeholder="Liste angeben"
      optionValue="id"  [(ngModel)]="taskModel.selectedValidationId" (ngModelChange)="setValidationList(taskModel.selectedValidationId)"></p-select>
    </div>
    <div class="field col-4">
      <label  class="w-full"  for="manager">EmpfängerIn</label>
      <p-select  class="w-full"  appendTo="body" [disabled]="this.isReadOnly" id="manager"  [options]="selectSomaContactData()"
        [(ngModel)]="taskModel.userId" optionLabel="friendlyName"
        optionValue="id"
        placeholder="EmpfängerIn wählen" appendTo="body"></p-select>
    </div>
  </div>
  <div class="p-formgrid grid">
    <div class="field col-12">
      <label  class="w-full" for="beschreibung">Beschreibung</label>
      <textarea fluid class="w-full"  [disabled]="this.isReadOnly" id="beschreibung" rows="3" maxlength="2000" pTextarea
        [(ngModel)]="taskModel.taskDescription"></textarea>
    </div>
  </div>


<div class="grid col-12 formAreaSeparatorTop">
  <div class="col">&nbsp;</div>
  <div class="field col-2">
    <p-button  [disabled]="!canSave()" label="Speichern" severity="info" styleClass=" justify-content-end" (onClick)="saveTask()"></p-button>
  </div>
  <div class="field col-2">
    <p-button    [disabled]="!canClose()" label="Beenden" severity="info" styleClass=" justify-content-end" (onClick)="close()"></p-button>
  </div>
</div>

</div>



<p-confirmDialog appendTo="body" header="Bitte bestätigen:" icon="pi pi-exclamation-triangle" message="nix"
  rejectLabel="Abbrechen">
</p-confirmDialog>

